<swiper-container [pagination]="{ clickable: true }" class="artwork-details-swiper" #artworkSwiperRef>
    <swiper-slide swiperSlide *ngFor="let img of imageCarousel">
        <div>
            <img [src]="img.view_image" alt="">
        </div>
    </swiper-slide>
</swiper-container>